<template>
  <collapse-portlet title="Customer Info" icon="la la-info-circle" :expanded="true">
    <div v-if="name_has_changed" class="alert alert-ss-danger fade show" role="alert">
      <div class="alert-icon">
        <i class="flaticon-questions-circular-button" />
      </div>
      <div class="alert-text">
        {{ name_change_alert_text }}
      </div>
    </div>

    <div class="row">
      <form v-if="current_customer && current_customer.uuid"
            method="post"
            class="kt-form kt-form--fit kt-form--label-align-right kt-form--group-seperator-dashed"
            @submit.prevent="updateCustomer">
        <div>
          <div class="form-group kt-form__group row">
            <div class="col-12">
              <label>Organisation</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-building" /></span>
                </div>
                <input v-model="current_customer.organisation.name"
                       type="text"
                       name="name"
                       class="kt-input form-control"
                       autocomplete="off"
                       disabled>
              </div>
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Slug</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i>@</i></span>
                </div>
                <input v-model="current_customer.slug"
                       name="slug" type="text"
                       :class="{'form-control': true }"
                       class="kt-input" placeholder=""
                       autocomplete="off" disabled>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Name</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-user" /></span>
                </div>
                <input v-model="current_customer.name"
                       v-validate="'required|alpha_num_spaces'"
                       type="text"
                       name="name" :class="{'form-control': true, 'has-error': errors.has('name') }"
                       class="kt-input"
                       placeholder="" autocomplete="off"
                       disabled>
              </div>
              <transition name="fade">
                <p v-show="errors.has('name')" class="help is-danger">
                  {{ errors.first('name') }}
                </p>
              </transition>
              <span class="kt-form__help" />
            </div>

            <div class="col-12 col-md-4 mt-2">
              <label>Plan</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-map-o" /></span>
                </div>
                <select v-model="current_customer.plan_id" class="form-control kt-input"
                        name="plan">
                  <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                    {{ plan.label }}
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Status</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-lightbulb-o" /></span>
                </div>
                <select v-model="current_customer.status" class="dropdown-square form-control kt-input"
                        name="status">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Api Access</label>

              <input v-if="!selected_plan_has_api_access" type="text"
                     class="form-control"
                     value="not in plan" disabled>

              <div v-else class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-lightbulb-o" /></span>
                </div>
                <select v-model="current_customer.api_access" class="dropdown-square form-control kt-input"
                        name="api_access">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Ads Enabled</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-lightbulb-o" /></span>
                </div>
                <select v-model="current_customer.ads_enabled" class="dropdown-square form-control kt-input"
                        name="ads_enabled">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Storage Allocation</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text icon-color">GB</span>
                </div>
                <input v-model="current_customer.storage_allocation"
                       v-validate="'required|numeric'"
                       type="text" class="form-control kt-input"
                       name="storage_allocation" :class="{'form-control': true, 'has-error': errors.has('storage_allocation')}"
                       placeholder="">
              </div>
              <span class="kt-form__help" />
              <transition name="fade">
                <p v-show="errors.has('storage_allocation')" class="help is-danger">
                  {{ errors.first('storage_allocation') }}
                </p>
              </transition>
            </div>
            <div class="col-12 col-md-4 mt-2">
              <label>Live Feed Limit</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-rss" /></span>
                </div>
                <input v-model="current_customer.live_feed_limit"
                       v-validate="'required|numeric'"
                       type="text" class="form-control kt-input"
                       name="live_feed_limit" :class="{'form-control': true, 'has-error': errors.has('live_feed_limit')}"
                       placeholder="">
              </div>
              <transition name="fade">
                <p v-show="errors.has('live_feed_limit')" class="help is-danger">
                  {{ errors.first('live_feed_limit') }}
                </p>
              </transition>
            </div>

            <div class="col-12 col-md-4 mt-2">
              <label>Label Item as Episode</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-rss" /></span>
                </div>
                <select v-model="current_customer.item_is_episode" class="dropdown-square form-control kt-input"
                        name="item_is_episode">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <transition name="fade">
                <p v-show="errors.has('item_is_episode')" class="help is-danger">
                  {{ errors.first('item_is_episode') }}
                </p>
              </transition>
            </div>

            <div class="col-12 col-md-4 mt-2">
              <label>Enable Direct Uploads Endpoint</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-rss" /></span>
                </div>
                <select v-model="current_customer.direct_upload_enabled" class="dropdown-square form-control kt-input"
                        name="direct_upload_enabled">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <transition name="fade">
                <p v-show="errors.has('direct_upload_enabled')" class="help is-danger">
                  {{ errors.first('direct_upload_enabled') }}
                </p>
              </transition>
            </div>
            <div class="col-12 col-md-6 mt-4">
              <label for="item_feed_token">Item Feed Token</label> <a href="javascript:;" @click="() => fireModal('item_feed_description')"><span class="la la-question-circle" /></a>
              <div class="input-group">
                <input id="item_feed_token" v-model="current_customer.item_feed_token"
                       type="password"
                       class="form-control"
                       placeholder="Password">
                <div class="input-group-append">
                  <button type="button" class="btn btn-ss-standout" @click="setItemFeedToken">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mt-4">
              <div class="alert alert-secondary" role="alert">
                <div class="alert-icon">
                  <i class="flaticon-questions-circular-button" />
                </div>
                <div class="alert-text">
                  <strong>Recommended Live Feed Limits</strong><br>
                  Basic = 0<br>
                  Pro = 2<br>
                  Enterprise = 50
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <button class="btn btn-ss-standout" type="button" @click.prevent="updateCustomer">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <confirm-modal v-if="current_customer" name="item_feed_token_confirm" title="Item Feed Token">
      <p v-if="current_customer.item_feed_enabled && !current_customer.item_feed_token">
        You are about to remove access to the Item Feed for this customer. Removing this token could break a customers
        integrated system. Are you sure you want to proceed ?
      </p>
      <p v-else>
        The customer already has a token set. Changing the token could break a customers integrated system.
        Are you sure you want to proceed ?
      </p>
    </confirm-modal>

    <vjs-modal name="item_feed_description" title="Item Feeds">
      <template slot="body-content">
        <p>
          Timbre has the functionality to hit the endpoint <a :href="`https://timbrecms.sharp-stream.com/item-feed/${current_customer.uuid}?token=xxx`">https://timbrecms.sharp-stream.com/item-feed/{{ current_customer.uuid }}?token=xxx</a> to retrieve a feed of all published items.
          This requires a token.
        </p>
        <p>
          Ensure to store the token elsewhere as it will not be retrievable. Do not update this token without first notifying the customer.
        </p>
        <p>
          To retrieve in Pv1 format use append <i>&legacy=true</i> to the url.
        </p>
      </template>
    </vjs-modal>
  </collapse-portlet>
</template>

<script>
import CollapsePortlet from "VueComponents/CollapsePortlet";
import ManageCustomersMixin from "VueMixins/ManageCustomersMixin";
import ConfirmModal from "VueModals/ConfirmModal";
import VjsModal from "VueModals/VjsModal";

export default {
  components: {
    VjsModal,
    ConfirmModal,
    CollapsePortlet,
  },
  mixins: [ManageCustomersMixin],
  props: {
    customer: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    plans: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    current_customer: {},
    api_access_in_plan: false,
    name_change_alert_text: "Changing customer will change the customer slug, and their storage directory. Be sure you want to do this before saving.",
  }),
  computed: {
    name_has_changed() {
      if (!this.current_customer || !this.customer) {
        return false;
      }
      return this.current_customer.name !== this.customer.name;
    },
    selected_plan() {
      return _.find(this.plans, plan => plan.id === this.current_customer.plan_id);
    },
    selected_plan_has_api_access() {
      return _.find(this.selected_plan.features, feature => feature.slug === 'api');
    },
  },
  mounted() {
    this.current_customer = Object.assign({}, this.customer);
    this.setupPreferences();
    if (this.current_customer.item_feed_enabled) {
      this.current_customer.item_feed_token = "xxxx";
    }
    // this.initPortlet('customer_info_portlet');
  },
  methods: {
    getPreference(key) {
      const preference = _.find(this.current_customer.preferences, {
        'preference': key,
      });

      if (preference) {
        if (preference.value === "1" || preference.value === "0") return Boolean(Number(preference.value));
        return preference.value;
      }

      return false;
    },
    setupPreferences() {
      this.current_customer.item_is_episode = this.getPreference('item_is_episode') ? 1 : 0;
      this.current_customer.direct_upload_enabled = this.getPreference('direct_upload_enabled') ? 1 : 0;
    },
    async setItemFeedToken() {
      if (this.current_customer.item_feed_enabled) {
        const modal_res = await this.fireModal('item_feed_token_confirm');
        if (modal_res.data.confirm) {
          try {
            await axios.patch(`/api/v1/admin/customer/${this.current_customer.uuid}/set-item-feed-token`, {
              item_feed_token: this.current_customer.item_feed_token,
            });
            toastr.success("Token Set.");
          } catch (error) {
            window.handleAxiosError(error);
          }
        }
      } else {
        try {
          await axios.patch(`/api/v1/admin/customer/${this.current_customer.uuid}/set-item-feed-token`, {
            item_feed_token: this.current_customer.item_feed_token,
          });
          toastr.success("Token Set.");
        } catch (error) {
          window.handleAxiosError(error);
        }
      }
    },

    updateCustomer() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.name_has_changed) {
            const res = await this.quickAlert({
              title: `Are you sure?`,
              message: this.name_change_alert_text,
              showCancel: true,
              'confirm-text': `Save`,
            });
            if (res.data.confirm) {
              this.submitForm();
            }
          } else {
            this.submitForm();
          }
        } else {
          toastr.error("Some fields have not been completed correctly");
        }
      });
    },
    submitForm() {
      const form_data = {
        plan_id: this.current_customer.plan_id,
        status: this.current_customer.status,
        api_access: this.current_customer.api_access,
        slug: this.current_customer.slug,
        storage_allocation: this.current_customer.storage_allocation,
        ads_enabled: this.current_customer.ads_enabled,
        live_feed_limit: this.current_customer.live_feed_limit,
        item_is_episode: this.current_customer.item_is_episode,
        direct_upload_enabled: this.current_customer.direct_upload_enabled,
      };

      axios.put(`/api/v1/admin/customer/${this.current_customer.uuid}`, form_data).then((response) => {
        toastr.success('Information updated.');
        EventBus.$emit('customer-updated', response.data.data);
      }).catch((error) => {
        if (error.response.data.error) {
          toastr.error(error.response.data.error.message);
        } else {
          toastr.error('Something went wrong. Please try again later.');
        }
      });
    },
  },
};
</script>
